import * as React from "react";
import { MenuItem, Paper } from "@mui/material";
import Downshift from "downshift";

export type AutocompleteProps<T> = {
  dropdownItems: T[];
  renderInput(dropdownProps: DropdownProps): React.JSX.Element;
  itemToSuggestion?(item: T): string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & any;

const classNameBase = `scd-autocomplete`;

export interface DropdownProps {
  clearSelection: void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getInputProps: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getItemProps: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRootProps: any;
  highlightedIndex: number | null;
  inputValue: string;
  isOpen: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedItem: any;
  menuItemStyles?: string;
}

const Autocomplete = <T,>({
  renderInput,
  dropdownItems,
  itemToSuggestion,
  ...downshiftProps
}: AutocompleteProps<T>): React.JSX.Element => {
  return (
    <div>
      <Downshift {...downshiftProps}>
        {({
          clearSelection,
          getInputProps,
          getItemProps,
          highlightedIndex,
          inputValue,
          isOpen,
          selectedItem,
        }: DropdownProps): React.JSX.Element => (
          <div className={`${classNameBase}-root`}>
            <div>
              {renderInput({
                clearSelection,
                getInputProps,
                getItemProps,
                highlightedIndex,
                inputValue,
                isOpen,
                selectedItem,
              })}
            </div>
            <div className={`${classNameBase}-dropdown-container`}>
              {isOpen && dropdownItems && dropdownItems.length > 0 ? (
                <Paper square>
                  {dropdownItems &&
                    dropdownItems.map((item: T, index: number) => {
                      const suggestion = itemToSuggestion
                        ? itemToSuggestion(item)
                        : item;
                      const isHighlighted = highlightedIndex === index;
                      const itemProps = getItemProps({
                        item: suggestion,
                      });

                      return (
                        <MenuItem
                          title={suggestion}
                          className={`${classNameBase}-dropdown-item`}
                          {...itemProps}
                          key={`${suggestion} ${index}`}
                          selected={isHighlighted}
                          component="div"
                        >
                          {suggestion}
                        </MenuItem>
                      );
                    })}
                </Paper>
              ) : null}
            </div>
          </div>
        )}
      </Downshift>
    </div>
  );
};

export default Autocomplete;
